import React from "react";
import { Typography, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { cpfOrCnpjFormat } from "utils/formatByText";

import * as Styled from "./styles";
import { getDisplayPhone, getDisplayValue } from "./utils";

export interface DealerProfileProps {
  legalName: string;
  tradeName: string;
  email: string;
  taxpayerId: string;
  telephone: {
    number: string;
    areaCode: string;
    countryCode: string;
  };
  cellphone: {
    number: string;
    areaCode: string;
    countryCode: string;
  };
  address: {
    street: string;
    number: string;
    neighborhood: string;
    city: string;
    postalCode: string;
    complement?: string;
    uf?: string;
    state?: string;
    apartment?: string;
  };
  cnpj?: string;
  website?: string;
  unit: string;
  subunit: string;
}

const DealerProfile: React.FC<{ data: DealerProfileProps | null }> = ({
  data,
}) => {
  const { t } = useTranslation();

  if (!data) {
    return null;
  }

  return (
    <Styled.Container>
      <Typography>{t("storeInformation")}</Typography>
      <Styled.StyledGrid
        container
        mt={3}
        padding={2}
        borderRadius={0.8}
        rowSpacing={2}
      >
        <Grid item sm={6} md={6}>
          <Typography>{t("socialReason")}</Typography>
          <Typography>{getDisplayValue(data.legalName)}</Typography>
        </Grid>
        <Grid item md={6} xs={6}>
          <Typography>{t("fantasyName")}</Typography>
          <Typography>{getDisplayValue(data.tradeName)}</Typography>
        </Grid>
        <Grid item sm={6} md={6}>
          <Typography>CNPJ</Typography>
          <Typography>
            {getDisplayValue(cpfOrCnpjFormat(data.taxpayerId))}
          </Typography>
        </Grid>
        <Grid item sm={6} md={6}>
          <Typography>{t("email")}</Typography>
          <Typography>{getDisplayValue(data.email)}</Typography>
        </Grid>
        <Grid item sm={6} md={6}>
          <Typography>{t("unit")}</Typography>
          <Typography>{getDisplayValue(data.unit)}</Typography>
        </Grid>
        <Grid item sm={6} md={6}>
          <Typography>{t("subunit")}</Typography>
          <Typography>{getDisplayValue(data.subunit)}</Typography>
        </Grid>

        <Grid item sm={6} md={6}>
          <Typography>{t("telephone")}</Typography>
          <Typography>
            {getDisplayPhone(data.telephone, data.cellphone)}
          </Typography>
        </Grid>
      </Styled.StyledGrid>
      <Styled.StyledGrid
        container
        mt={3}
        padding={2}
        borderRadius={0.8}
        rowSpacing={2}
      >
        <Grid item md={3} xs={3}>
          <Typography>{t("street")}</Typography>
          <Typography>{getDisplayValue(data.address.street)}</Typography>
        </Grid>
        <Grid item md={3} xs={3}>
          <Typography>{t("number")}</Typography>
          <Typography>{getDisplayValue(data.address.number)}</Typography>
        </Grid>
        <Grid item md={3} xs={3}>
          <Typography>{t("complement")}</Typography>
          <Typography>{getDisplayValue(data.address.apartment)}</Typography>
        </Grid>
        <Grid item md={3} xs={3}>
          <Typography>{t("postalCode")}</Typography>
          <Typography>{getDisplayValue(data.address.postalCode)}</Typography>
        </Grid>
        <Grid item md={3} xs={3}>
          <Typography>{t("neighborhood")}</Typography>
          <Typography>{getDisplayValue(data.address.neighborhood)}</Typography>
        </Grid>
        <Grid item md={3} xs={3}>
          <Typography>{t("city")}</Typography>
          <Typography>{getDisplayValue(data.address.city)}</Typography>
        </Grid>
        <Grid item md={3} xs={3}>
          <Typography>UF</Typography>
          <Typography>{getDisplayValue(data.address.state)}</Typography>
        </Grid>
      </Styled.StyledGrid>
    </Styled.Container>
  );
};

export default DealerProfile;
